import React from "react";
import { TableCell, Typography, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";
import { IValuesStore } from "Stores/Values/types";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { IManagementStore } from "@src/Stores/Management/types";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import { Theme } from "@src/Interfaces/Entity/Theme";
import ThemeEdit from "./ThemeEdit/ThemeEdit";
import DoneIcon from "@material-ui/icons/Done";
import { Values } from "@src/Tools/Values";
import { IThemesStore } from "@src/Stores/Themes/types";
import { IAuthStore } from "@src/Stores/Auth/types";
import { Location } from "@src/Interfaces/Entity/Location";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";

interface IProps {
  auth?: IAuthStore;
  theme: Theme;
  themes?: IThemesStore;
  values?: IValuesStore;
  management?: IManagementStore;
}

@inject("auth", "values", "management", "themes")
@observer
class ThemeTableItem extends React.Component<IProps> {
  @computed get isActive() {
    return this.props.theme.state === this.props.values.states.Active;
  }

  @computed get isNightTheme() {
    if (this.props.theme.isNightTheme) {
      return <DoneIcon />;
    }
    return null;
  }

  @computed get isDefaultTheme() {
    const location: Location = this.props.management.activeLocations.find(
      location => location.id === this.props.theme.locationId
    );
    if (location && location.primary && this.props.theme.state === this.props.values.states.Active) {
      return <DoneIcon />;
    }
    return null;
  }

  @computed get themeType() {
    if (this.props.theme.type === this.props.values.themeTypes.Login) {
      return Values.getLocalizationValue("login");
    } else if (this.props.theme.type === this.props.values.themeTypes.Application) {
      return Values.getLocalizationValue("application");
    }
  }

  getLocationName = (locationId: string) => {
    const location: Location = this.props.management.activeLocations.find(location => location.id === locationId);
    return location ? location.name : "";
  };

  handleRemove = async () => {
    await this.props.management.removeTheme(this.props.theme.id);
    await this.props.management.getThemes();
    if (
      this.props.theme.type === this.props.values.themeTypes.Application &&
      this.props.theme.state === this.props.values.states.Active
    ) {
      await this.props.themes.getCurrentTheme(this.props.values.themeTypes.Application);
    }
    return;
  };

  render() {
    const theme: Theme = this.props.theme;
    return (
      <STTableRow hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <Typography>
            <STTableCellTypography>{theme.name}</STTableCellTypography>
          </Typography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{theme.description}</STTableCellTypography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{this.themeType}</STTableCellTypography>
        </TableCell>
        <TableCell align="center" size="small">
          {this.isNightTheme}
        </TableCell>
        {this.props.auth.user.location.primary && (
          <>
            <TableCell size="small">
              <STTableCellTypography>{this.getLocationName(theme.locationId)}</STTableCellTypography>
            </TableCell>
            <TableCell size="small">{this.isDefaultTheme}</TableCell>
          </>
        )}
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {(this.props.auth.user.location.primary || this.props.auth.user.location.id === theme.locationId) && (
              <>
                <ThemeEdit theme={theme} />
                <EntityDelete onSubmit={this.handleRemove} />
              </>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default ThemeTableItem;
